import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserDataRequestService {

  private isRefisPeriodActive: Subject<boolean> = new Subject<boolean>();
  private requerenteSubject = new BehaviorSubject<any>(null);
  private isRepresentingAnotherPerson: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private representativeData = new BehaviorSubject<any>(null);
  constructor() { }

  addValueRefisPeriodActive(isActive: boolean): void {
    this.isRefisPeriodActive.next(isActive);
  }
  
  getRefisPeriodStatus(): Observable<boolean> {
    return this.isRefisPeriodActive.asObservable();
  }

  setRequerente(data: any) {
    this.requerenteSubject.next(data);
  }

  getRequerente(): Observable<any> {
    return this.requerenteSubject.asObservable();
  }

  setRepresentingAnotherPerson(value: boolean): void {
    this.isRepresentingAnotherPerson.next(value);
  }

  getRepresentingAnotherPerson(): Observable<boolean> {
    return this.isRepresentingAnotherPerson.asObservable();
  }
}